import React, { Component }  from 'react';
import {connect}             from 'react-redux';
import RenderHeader          from '../../../container/renderHeader';
import {Link}                from 'react-router-dom';
import { GetFeedBackTarefa } from '../../../actions/tarefaAction';
import "../../../css/aluno/quest_box.css";


class missao_concluir extends Component {

    constructor(props){
		super(props);
		this.state = { tar_id:this.props.match.params.id,dados:[]}
    }
	
	componentWillMount() {
        this.props.GetFeedBackTarefa(this.props.session.id,this.state.tar_id).then((response)=>{
            this.setState({dados:response.data});
        })
    }

    render() {
	const icon = {}
        return (
            <div className="hud-middle-center active">

<RenderHeader titulo="Missões"/>

<main className="hud-middle-center-content">
					<div className="quest-box quest-box-alternative">
		<div className="quest-box-header">
			<div className="quest-box-header-decoration"></div>
			<div className="quest-box-header-info">
				<div className="quest-box-header-info-tools">
				<Link to={this.props.menu.missao.home} className="simple-action">&times;</Link>
				</div>
			</div>
		</div>
		<div className="quest-box-body">
			<div className="quest-box-left">
				<div className="quest-box-title-alternative quest-box-title-alternative-with-icon" style={icon}>
					{/* <i className="gamefica-icon gamefica-message"></i> */}
					<div className="quest-box-title-alternative-content">
						{this.state.dados.tar_titulo}
						{/* <div className="quest-box-title-alternative-subtitle">
						{this.state.dados.dis_nome}
						</div> */}
					</div>
				</div>
				<div className="quest-box-text hud-scroll-tip">
				{this.state.dados.ent_tar_feedback}
				</div>
			</div>
			<div className="quest-box-right hud-scroll-tip">
				<div className="quest-box-right-description">
					<div className="quest-box-text-line">
						{this.state.dados.use_nome}
					</div>
					<div className="quest-box-text-line quest-box-text-line-small">
					{this.state.dados.dis_nome}
					</div>
				</div>
				<div className="quest-box-right-info quest-box-background-active">
					<div className="quest-box-title">
						RECOMPENSA
					</div>
					<div className="quest-box-text">
						<div className="quest-box-marker">
							<span>	{this.state.dados.ent_tar_pontuacao?this.state.dados.ent_tar_pontuacao:"00"}</span>
						</div>
					</div>

						<div className="quest-box-info">
						<div className="quest-box-row">
							<div className="quest-box-column quest-box-column-text">
							
							 {this.state.dados.tar_txt_recompensa}
							
							</div>
						</div>
					</div>
					<div className="quest-box-info">
						<div className="quest-box-row">
							<div className="quest-box-column quest-box-background-pattern">
								<div className="quest-box-hex quest-box-hex-vertical quest-box-hex-small">
									<div className="quest-box-hex-label quest-box-hex-label-primary">
										PTS
									</div>
									<div className="quest-box-hex-value">
										{this.state.dados.tar_pontos}
									</div>
								</div>
							</div>
							<div className="quest-box-column quest-box-background-pattern">
								<div className="quest-box-hex quest-box-hex-vertical quest-box-hex-small">
									<div className="quest-box-hex-label quest-box-hex-label-gold">
										XP
									</div>
									<div className="quest-box-hex-value">
									{this.state.dados.tar_xp}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.state.dados.tar_anexo ?
				<div className="quest-box-right-actions">
					<a href={this.state.dados.tar_anexo} target='_blank' className="action action-fluid">Baixar&nbsp;Atividade</a>
				</div>
				:""
				}
			</div>
		</div>
	</div>
			</main>
                </div>


        );
    }
}



function mapStateToProps(state){

    return {session: state.auth.session,menu: state.configReducer.menu}

}

export default connect(mapStateToProps,{GetFeedBackTarefa})(missao_concluir);




// WEBPACK FOOTER //
// ./src/components/aluno/missao/missao_recompensa.js